import clsx, { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Teach tailwind-merge the Design System font sizes. Otherwise it reads e.g.
// `text-footnote` as a colour and drops `text-white` from the same element.
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{ text: ['display', 'avatar-xl', 'headline', 'title', 'body', 'body-strong', 'callout', 'footnote', 'caption', 'micro'] }],
        },
    },
});

export const clsxMerge = (...classes: ClassValue[]): string =>
    twMerge(clsx(...classes));
